import { ApiService } from '../apiService'
import type {
  SubscriptionPlanDto,
  UserSubscriptionDto,
  PaymentHistoryResponse,
  UserCreditsResponse,
  AdminSubscriptionCreditDto,
  GrantCreditRequest,
} from '../types/subscription'

export const subscriptionsApi = {
  // Get all subscription plans (public endpoint)
  getPlans: () => ApiService.get<SubscriptionPlanDto[]>('/api/subscription-plans'),

  // Get a specific plan by ID (public endpoint)
  getPlan: (id: string) => ApiService.get<SubscriptionPlanDto>(`/api/subscription-plans/${id}`),

  // Get current user's subscription (creates free tier if none exists)
  getCurrentSubscription: () => ApiService.get<UserSubscriptionDto>('/api/me/subscription'),

  // Get user's payment history with pagination
  getPaymentHistory: (page: number = 1, pageSize: number = 20) =>
    ApiService.get<PaymentHistoryResponse>('/api/me/payments', { page, pageSize }),

  // ==================
  // USER CREDITS
  // ==================

  // Get user's available credits
  getMyCredits: () => ApiService.get<UserCreditsResponse>('/api/me/credits'),

  // Redeem a credit
  redeemCredit: (creditId: string) =>
    ApiService.post<UserSubscriptionDto>(`/api/me/credits/${creditId}/redeem`),

  // ==================
  // ADMIN CREDITS
  // ==================

  // Grant credit to a user (admin only)
  grantCredit: (data: GrantCreditRequest) =>
    ApiService.post<AdminSubscriptionCreditDto>('/admin/subscription-credits', data),

  // Get a user's credits (admin only)
  getUserCredits: (userId: string) =>
    ApiService.get<AdminSubscriptionCreditDto[]>(`/admin/subscription-credits/user/${userId}`),

  // Revoke a pending credit (admin only)
  revokeCredit: (creditId: string) =>
    ApiService.delete<void>(`/admin/subscription-credits/${creditId}`),
}
